export enum PivotDefinitieType {
  Leads = 1,
  Orders = 2
}